//    Copyright 2020 Siemens
import {default as SPLM} from "../no/splm.js";
import "../no/MPA.js";
import "../no/Object.js";
import "../no/Session.js";
let d=[[],[[["part","mpaSheetTag"],"CreateNewSheetBuilder",{R_:{builder:"MPA.NewSheetBuilder"}},2,1],[["part"],"CreatePreferencesBuilder",{R_:{builder:"MPA.PreferencesBuilder"}},1,0],[["part","mpaManualGroupTag"],"CreateManualGroupBuilder",{R_:{builder:"MPA.ManualGroupBuilder"}},2,0],[["part"],"CreateUpdateDiagramBuilder",{R_:{builder:"MPA.UpdateDiagramBuilder"}},1,0],[["part","mpaSheetTag"],"CreateNewPadSheetBuilder",{R_:{builder:"MPA.NewPADSheetBuilder"}},2,0],[["part","mpaSheetTag"],"CreateNewIcdSheetBuilder",{R_:{builder:"MPA.NewICDSheetBuilder"}},2,0]],[["SheetOperations","MPA.SheetOperations",0]]];
SPLM.MPA.MpaManager = class extends SPLM.Object{
    constructor (creator){
        super(creator);
        this._d['Class'] = "SPLM.MPA.MpaManager";
        SPLM.c$d(this.Class,d);d=[];
    }
};

export default SPLM;